define('modules/editor/views/brick_view_factory',['require','exports','module','./element_view_factory','./elements/area'],function(require, exports, module) {
  
  var ElementViewFactory = require("./element_view_factory"),
      AreaView = require("./elements/area");

  // The only purpose of this class is to decouple Area View from the rest of the element views
  module.exports = function(options){
    return options.model.name === "element:area"? new AreaView(options) : ElementViewFactory(options);
  };
});

